import React, { useState } from 'react';
import API_BASE_URL from '../config';

interface ForgotPasswordFormProps {
  onBack: () => void;
  onResetTokenReceived: (token: string, email: string) => void;
}

const ForgotPasswordForm: React.FC<ForgotPasswordFormProps> = ({ onBack, onResetTokenReceived }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess(false);

    try {
      const response = await fetch(`${API_BASE_URL}/api/auth/forgot-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok && data.success) {
        setSuccess(true);
        // In development, we get the token back for testing
        if (data.reset_token) {
          onResetTokenReceived(data.reset_token, email);
        }
      } else {
        setError(data.error || 'Failed to send reset email');
      }
    } catch (err) {
      setError('Network error. Please try again.');
    }

    setLoading(false);
  };

  return (
    <div className="auth-form">
      <h2>Reset Password</h2>
      
      {error && (
        <div className="error-message">
          {error}
        </div>
      )}

      {success && (
        <div className="success-message">
          Password reset instructions have been sent to your email.
        </div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="email">Email Address</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            disabled={loading || success}
            placeholder="Enter your email address"
          />
        </div>

        <button
          type="submit"
          disabled={loading || success}
          className="submit-btn"
        >
          {loading ? 'Sending...' : 'Send Reset Link'}
        </button>
      </form>

      <div className="switch-mode">
        <p>
          Remember your password?{' '}
          <button onClick={onBack} disabled={loading}>
            Back to Sign In
          </button>
        </p>
      </div>
    </div>
  );
};

export default ForgotPasswordForm;
